import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import './benutzerverwaltung.module.scss';
import {benutzerverwaltungRun} from './benutzerverwaltung.route';
import {BenutzerRegViewComponentConfig} from './component/benutzerRegView/benutzerRegView';
import {BenutzerverwaltungAnlaufstelleViewComponentConfig} from './component/benutzerverwaltungAnlaufstelleView/benutzerverwaltungAnlaufstelleView';
import {BenutzerEditAnlaufstelleComponentConfig} from './component/benutzerEditAnlaufstelleView/benutzerEditAnlaufstelleView';
import {BenutzerListViewComponentConfig} from './component/benutzerListView/benutzerListView';
import {BenutzerEditComponentConfig} from './component/benutzerEditView/benutzerEditView';
import {BenutzerProfilViewComponentConfig} from './component/benutzerProfilViw/benutzerProfilView';

export const SerfWebBenutzerverwaltung = angular.module('serfWeb.benutzerverwaltung', [SerfWebCore.name])
    .component('dvBenutzereditAnlaufstelleView', new BenutzerEditAnlaufstelleComponentConfig())
    .component('dvBenutzereditView', new BenutzerEditComponentConfig())
    .component('dvBenutzerListView', new BenutzerListViewComponentConfig())
    .component('dvBenutzerverwaltungAnlaufstelleView', new BenutzerverwaltungAnlaufstelleViewComponentConfig())
    .component('benutzerRegView', new BenutzerRegViewComponentConfig())
    .component('dvBenutzerprofilView', new BenutzerProfilViewComponentConfig())
    .run(benutzerverwaltungRun);

export default SerfWebBenutzerverwaltung;



// WEBPACK FOOTER //
// ./src/app/benutzerverwaltung/benutzerverwaltung.module.ts